import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 1024px) {
    flex-direction: column;
  }

  p {
    font-size: 20px;
    line-height: 26px;
    margin-left: 19px;

    @media (max-width: 1024px) {
      margin-top: 24px;
      font-size: 14px;
      line-height: 18px;
      margin-left: 16px;
    }
  }

  img {
    margin-top: 6px;
    width: 200px;
    height: 200px;

    @media (max-width: 1024px) {
      margin-left: 16px;
    }
  }
`;

const MVDruten = (props) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <img src={require('assets/images/marcel-van-druten.png')} alt="" />
      <p>
        Marcel Van Druten is a seasoned professional with a proven record of achievement in global
        technology environments. Born and raised in Amsterdam, The Netherlands, until the age of 21
        Marcel actively played football as a fearless defender in the highest amateur leagues at
        various Football Clubs. <br />
        <br />
        Leveraging his deep marketing and advertising expertise, Marcel has helped global brands
        develop and implement programs and initiatives aimed at enhancing revenues and promoting
        brand awareness. Multilingual in English, Dutch, and German, and with a great passion for
        martial arts, golf and formula 1, Marcel is helping P4P become the best Sports App in the
        world.
      </p>
    </Wrapper>
  );
};

export default MVDruten;
